<template>
  <v-app>
    <div>
      <nav :style="navStyle">
        <div class="navbar">
          <v-row cols="12" :class="{ 'justify-start': isMobile ,}" justify="center">
            <v-col  cols="12" md="2">
              <v-btn icon v-if="isMobile" @click="toggleDrawer">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
              <img src="@/assets/syxpay/syxpay_logo.png" max-width="50px" class="mt-2"/>
              <v-navigation-drawer v-if="isMobile" v-model="drawer" app>
                <v-list>
                  <!-- <v-list-item @click="goToSection('#home')">{{ translate('home') }}</v-list-item> -->
                  <v-list-item @click="goToSection('#home')">{{ translate('home') }}</v-list-item>
                  <v-list-item @click="goToSection('#products')">{{ translate('product') }}</v-list-item>
                  <v-list-item @click="goToSection('#about')">{{ translate('about') }}</v-list-item>
                  <v-list-item @click="goToSection('#download')">{{ translate('download') }}</v-list-item>
                  <v-list-item>
                    <v-menu offset-y style="z-index: 999;">
                      <template v-slot:activator="{ on, attrs}">
                        <p v-on="on" v-bind="attrs">
                          {{ language === 'IN' ? 'IN' : 'EN' }}
                          <v-icon>
                            mdi-menu-down
                          </v-icon>
                        </p>
                      </template>
                      <v-list>
                        <v-list-item @click="switchLanguage('EN')">English</v-list-item>
                        <v-list-item @click="switchLanguage('IN')">Indonesia</v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item>
                </v-list>
              </v-navigation-drawer>
            </v-col>
            <v-col class="d-flex align-center" v-if="!isMobile" cols="12" md="7">
              <v-row class="d-flex align-center text-center">
                <v-col class="text-center">
                  <button>
                    <p style="color: black; font-size: large; margin-bottom: 0;" @click="goToSection('#home')" :class="{'active' : activeMenu == '#home'}">
                      {{ translate('home') }}
                    </p>
                  </button>
                </v-col>
                <v-col>
                  <button>
                    <p style="color: black; font-size: large; margin-bottom: 0;" @click="goToSection('#products')" :class="{'active' : activeMenu == '#products'}">
                      {{ translate('product') }}
                    </p>
                  </button>
                </v-col>
                <v-col>
                  <button>
                    <p style="color: black; font-size: large; margin-bottom: 0;" @click="goToSection('#about')" :class="{'active' : activeMenu == '#about'}">
                      {{ translate('about') }}
                    </p>
                  </button>
                </v-col>
                <v-col>
                  <button>
                    <p style="color: black; font-size: large; margin-bottom: 0;" @click="goToSection('#download')" :class="{'active' : activeMenu == '#download'}">
                      {{ translate('download') }}
                    </p>
                  </button>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="!isMobile" class="d-flex align-center justify-center" cols="12" md="1">
              <v-menu offset-y >
                <template v-slot:activator="{ on, attrs }">
                  <h1 style="color: black; font-size: x-large;" v-on="on" v-bind="attrs">
                    {{ language === 'IN' ? 'IN' : 'EN' }}
                    <v-icon>
                      mdi-menu-down
                    </v-icon>
                  </h1>
                </template>
                <v-list>
                  <v-list-item @click="switchLanguage('EN')">English</v-list-item>
                  <v-list-item @click="switchLanguage('IN')">Indonesia</v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </div>
      </nav>
    </div>
    <v-main>
      <!-- Your main content goes here -->
      <div class="mt-14">
        <home :translate="translate" />
      </div>
      <product :translate="translate" />
      <about :translate="translate" />
      <div style="overflow-x: hidden;">
        <partners :translate="translate" />
      </div>
      <foote :translate="translate" />
    </v-main>
  </v-app>
</template>

<script>
import product from "./components/ProductSection";
import foote from "./components/Footer";
import home from "./components/HomeSection";
import about from "./components/AboutSection";
import partners from "./components/PartnersSection";
import translations from "./assets/translations.json";


export default {
  name: "app",

  components: {
    product,
    foote,
    home,
    about,
    partners,
  },
  data() {
    return {
      isScrolled: false,
      drawer: false,
      tab: null,
      language: 'IN',
      activeMenu: '#home'
    };
  },
  computed: {
    navStyle() {
      return {
        backgroundColor: this.isScrolled ? 'rgba(255, 255, 255, 0.8)' : 'transparent',
        borderBottom: '1px solid rgba(97, 187, 70, 1)',
        backdropFilter: this.isScrolled ? 'blur(5px)' : 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        maxWidth: 100, 
        zIndex: 1000,
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0;
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    goToSection(id) {
      this.drawer = false;
      this.$vuetify.goTo(id);
      this.activeMenu = id;
    },
    switchLanguage(lang) {
      this.language = lang;
    },
    translate(key) {
      return translations[this.language][key];
    }
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Poppins:400,700,900');

.v-main {
  /* background-image: url("~@/assets/img/bgMain.png"); */
  background-attachment: fixed;
  background-position: center;
  background-size: cover;

  font-size: 20px;
  font-weight: 400;
  font-family: 'Poppins' !important;
}

nav {
  font-size: 20px;
  font-weight: 500;
  font-family: 'Poppins';
  vertical-align: middle;

  padding: 10px 10px;
  transition: background-color 0.3s, backdrop-filter 0.3s;
}

body {
  font-family: 'Poppins';
}

.transparent-tabs {
  background-color: transparent;
}

.active {
  /* border-bottom: solid 3px purple; */
  color: #0F4D81 !important;
  font-weight: bold;
  /* font-size: 28px !important; */
}
</style>
